import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./app/store";
import GlobalSpinner from "./CommonComponents/GlobalSpinner/GlobalSpinner";
import Wrapper from "./CommonComponents/Wrapper";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Wrapper>
    <Provider store={store}>
      <GlobalSpinner appContainer={<App />}></GlobalSpinner>
    </Provider>
  </Wrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
